import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class PeoplepulseService {
  hostURL = environment.apiUrl;
  centralDomain = environment.centralApi;
  constructor(private http: HttpClient) {}

  // STATE MASTER

  getAllStates(): Observable<any> {
    return this.http.get(`${this.hostURL}/states`);
  }

  createState(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/states`, data);
  }

  updateState(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/states/${id}`, data);
  }

  deleteState(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/states/${id}`);
  }

  getStateById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/states/${id}`);
  }

  getStatesByDistrict(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/states/getStatesByDistrict`, data);
  }

  // LOCATION MASTER

  getAllLocations(): Observable<any> {
    return this.http.get(`${this.hostURL}/location`);
  }

  createLocation(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/location`, data);
  }

  updateLocation(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/location/${id}`, data);
  }

  deleteLocation(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/location/${id}`);
  }

  getLocationById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/location/${id}`);
  }

  //Earning

  getAllEarnings(): Observable<any> {
    return this.http.get(`${this.hostURL}/earning`);
  }

  createEarning(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/earning`, data);
  }

  updateEarning(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/earning/${id}`, data);
  }

  deleteEarning(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/earning/${id}`);
  }

  getEarningById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/earning/${id}`);
  }

  //Deduction

  getAllDeduction(): Observable<any> {
    return this.http.get(`${this.hostURL}/deduction`);
  }

  createDeduction(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/deduction`, data);
  }

  updateDeduction(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/deduction/${id}`, data);
  }

  deleteDeduction(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/deduction/${id}`);
  }

  getDeductionById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/deduction/${id}`);
  }

  //Category

  getAllCategory(): Observable<any> {
    return this.http.get(`${this.hostURL}/category-designation`);
  }

  createCategory(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/category-designation`, data);
  }

  updateCategory(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/category-designation/${id}`, data);
  }

  deleteCategory(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/category-designation/${id}`);
  }

  getCategoryById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/category-designation/${id}`);
  }
  //Category Mapping

  getAllCategoryMapping(): Observable<any> {
    return this.http.get(`${this.hostURL}/category-mapping`);
  }

  createCategoryMapping(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/category-mapping`, data);
  }

  updateCategoryMapping(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/category-mapping/${id}`, data);
  }

  deleteCategoryMapping(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/category-mapping/${id}`);
  }

  getCategoryMappingById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/category-mapping/${id}`);
  }

  //Designation

  getAllDesignation(): Observable<any> {
    return this.http.get(`${this.hostURL}/designation`);
  }

  createDesignation(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/designation`, data);
  }

  updateDesignation(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/designation/${id}`, data);
  }

  deleteDesignation(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/designation/${id}`);
  }

  getDesignationById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/designation/${id}`);
  }

  getCategoryByDesignation(categoryId: number) {
    return this.http.get(`${this.hostURL}/designation/category/${categoryId}`);
  }

  //PAPL Designation

  getAllPaplDesignation(): Observable<any> {
    return this.http.get(`${this.hostURL}/papl-designation`);
  }

  createPaplDesignation(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/papl-designation`, data);
  }

  updatePaplDesignation(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/papl-designation/${id}`, data);
  }

  deletePaplDesignation(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/papl-designation/${id}`);
  }

  getPaplDesignationById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/papl-designation/${id}`);
  }

  //ESI/PF CODE MAPPING

  getAllEsipf(): Observable<any> {
    return this.http.get(`${this.hostURL}/esic-pf-mapping`);
  }

  createEsipf(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/esic-pf-mapping`, data);
  }

  updateEsipf(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/esic-pf-mapping/${id}`, data);
  }

  deleteEsipf(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/esic-pf-mapping/${id}`);
  }

  getEsipfById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/esic-pf-mapping/${id}`);
  }

  //Branch
  getAllBranch(): Observable<any> {
    return this.http.get(`${this.hostURL}/branch`);
  }

  //SalaryRange

  getAllSalaryrange(): Observable<any> {
    return this.http.get(`${this.hostURL}/salary-range`);
  }

  createSalaryrange(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/salary-range`, data);
  }

  updateSalaryrange(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/salary-range/${id}`, data);
  }

  deleteSalaryrange(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/salary-range/${id}`);
  }

  getSalaryrangeById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/salary-range/${id}`);
  }

  //Search Salary Range

  searchSalaryRange(data: any) {
    return this.http.post(
      `${environment.apiUrl}/salary-range/searchSalaryRange`,
      data,
    );
  }

  // Calculate Monthly Salary
  calculateMonthlySalary(data: any) {
    return this.http.post(
      `${this.hostURL}/salary-calculation/calculate-monthly-salary`,
      data,
    );
  }

  // Calculate Daily Salary
  calculateDailySalary(data: any) {
    return this.http.post(
      `${this.hostURL}/salary-calculation/calculate-daily-salary`,
      data,
    );
  }

  // Get Salary Calculation List
  getSalaryCalculationList(data: any) {
    return this.http.post(
      `${environment.apiUrl}/salary-calculation/get-salary-calculation-list`,
      data,
    );
  }

  isMonthlySalaryCalculated(data: any) {
    return this.http.post(
      `${environment.apiUrl}/salary-calculation/is-monthly-salary-calculated`,
      data,
    );
  }

  // Update Salary List
  updateSalaryList(data: any) {
    return this.http.post(
      `${environment.apiUrl}/salary-calculation/update-salary-list`,
      data,
    );
  }

  uploadSalaryExcel(formData: FormData) {
    return this.http.post(
      `${environment.apiUrl}/salary-calculation/upload-salary-excel`,
      formData,
    );
  }

  getLocationsByState(stateid: number) {
    return this.http.get<any>(`${this.hostURL}/location/state/${stateid}`);
  }
  getBranchByLocation(locationId: number) {
    return this.http.get(`${this.hostURL}/location/branch/${locationId}`);
  }
  getPccByBranch(branchId: number) {
    return this.http.get(`${this.hostURL}/location/pcc/${branchId}`);
  }

  getSEctionByPccc(branchId: number) {
    return this.http.get(`${this.hostURL}/location/section/${branchId}`);
  }

  //get all Temporary Enrollment

  createTemporaryEnrollment(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/temporary-enrollment`, data);
  }

  updateTemporaryEnrollment(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/temporary-enrollment/${id}`, data);
  }

  getTemporaryEnrollment(): Observable<any> {
    return this.http.get(`${this.hostURL}/temporary-enrollment`);
  }

  getQualificationByTempId(temp_id: number) {
    return this.http.get<any>(
      `${this.hostURL}/temporary-enrollment/qualification/${temp_id}`,
    );
  }

  deleteTemporaryEnrollment(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/temporary-enrollment/${id}`);
  }

  createEmployment(data: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/temporary-enrollment/employment`,
      data,
    );
  }

  createMaster(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/temporary-enrollment/master`, data);
  }

  createQualification(data: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/temporary-enrollment/qualification`,
      data,
    );
  }

  createBankdetails(data: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/temporary-enrollment/bankdetails`,
      data,
    );
  }

  createNomineedetails(data: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/temporary-enrollment/nomineedetails`,
      data,
    );
  }

  createFamilydetails(data: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/temporary-enrollment/familydetails`,
      data,
    );
  }

  saveAllEnrolmentDocs(temp_id: number, data: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/temporary-enrollment/alldocs/${temp_id}`,
      data,
    );
  }

  getFamilydetailsByTempId(temp_id: number) {
    console.log("Service Called: temporary-enrollment/familydetails/", temp_id);
    return this.http.get<any>(
      `${this.hostURL}/temporary-enrollment/familydetails/${temp_id}`,
    );
  }

  createEpfesicdetails(data: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/temporary-enrollment/epfesicdetails`,
      data,
    );
  }

  createAttendance(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/attendance`, data);
  }

  getPostingEmployee(payload: any) {
    return this.http.post<any>(
      `${this.hostURL}/attendance/posting_employee`,
      payload,
    );
  }

  dailyAttendanceImport(payload: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/attendance/dailyAttendanceImport`,
      payload,
    );
  }

  downloadDailyAttendanceSample(payload: any): Observable<Blob> {
    return this.http.post(
      `${this.hostURL}/attendance/dailyAttendanceSampleExport`,
      payload,
      { responseType: "blob" },
    );
  }

  approveDailyAttendance(payload: any): Observable<any> {
    return this.http.post(`${this.hostURL}/attendance/approve`, payload);
  }

  allApprovedAttendance(payload: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/attendance/all-approved-attendances`,
      payload,
    );
  }

  autoSaveAttendance(payload: any) {
    return this.http.post(
      `${this.hostURL}/attendance/auto-save-attendance`,
      payload,
    );
  }
getEnrollmentData(paplId: string) {
  return this.http.get<any>(`${this.hostURL}/enrollment/get-enrollment-data/${paplId}`);
}
  getEnrollment() {
    return this.http.get<any>(`${this.hostURL}/enrollment`);
  }
  PlaceOfPostingCreate(payload: any) {
    return this.http.post<any>(`${this.hostURL}/postinghistory`, payload);
  }
  getPostinghistoryData() {
    return this.http.get<any>(`${this.hostURL}/postinghistory`);
  }
  PlaceOfPostingUpdate(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/postinghistory`, data);
  }
  getPostingHistoryById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/postinghistory/${id}`);
  }
  fetchPostingdata(papl_id: string): Observable<any> {
    return this.http.get(
      `${this.hostURL}/postinghistory/fetch-posting-data/${papl_id}`,
    );
  }

  PromotionCreate(payload: any) {
    return this.http.post<any>(
      `${this.hostURL}/postinghistory/promotion-posting`,
      payload,
    );
  }
  getPromotionDetails(papl_id: string) {
    return this.http.get(
      `${this.hostURL}/postinghistory/promotion-details/${papl_id}`,
    );
  }

  setManpower(data: any) {
    return this.http.post(
      `${this.hostURL}/profitcostcenter/set-manpower`,
      data,
    );
  }
  setD_NPCC(data: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/profitcostcenter/set-d-n`,
      data,
    );
  }
  setPostingUpdateDNPCC(data: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/profitcostcenter/set-posting-update-d-n`,
      data,
    );
  }
  setSalaryPeriodPCC(data: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/profitcostcenter/set-salary-date`,
      data,
    );
  }
  viewSalary(id: any): Observable<any> {
    return this.http.get<any>(
      `${this.hostURL}/profitcostcenter/view-salary-date/${id}`,
    );
  }
  ptRuleOverwrite(payload: any): Observable<any> {
    return this.http.post<any>(
      `${this.hostURL}/profitcostcenter/pt-rule-overwrite`,
      payload,
    );
  }
  getPtRuleOverwrite(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.hostURL}/profitcostcenter/pt-rule-overwrite/${id}`,
    );
  }
  checkAttendanceEnrollment(profit_cost_id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/profitcostcenter/check-attendance-enrollment/${profit_cost_id}`);
  }
  getProfitCostCenter(): Observable<any> {
    return this.http.get(`${this.hostURL}/profitcostcenter/index`);
  }
  getProfitCostCenterById(id: number) {
    return this.http.get(`${this.hostURL}/profitcostcenter/${id}`);
  }
  getManpowerByProfitCostId(id: number) {
    return this.http.get(`${this.hostURL}/profitcostcenter/set-manpower/${id}`);
  }
  getCapacity(profit_cost_id: number, designation?: number) {
    if (designation) {
      return this.http.get(
        `${environment.apiUrl}/profitcostcenter/capacity/${profit_cost_id}/${designation}`,
      );
    }
    return this.http.get(
      `${environment.apiUrl}/profitcostcenter/capacity/${profit_cost_id}`,
    );
  }
  getPostingData(payload: any) {
    return this.http.post<any>(
      `${this.hostURL}/salary/posting_employee`,
      payload,
    );
  }
  SalaryEffectivedate(payload: any) {
    return this.http.post<any>(`${this.hostURL}/salary`, payload);
  }
  getSalaryEffectivedate(): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/salary`);
  }

  //SlabMaster

  getAllSlab(): Observable<any> {
    return this.http.get(`${this.hostURL}/slabmaster`);
  }

  createSlab(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/slabmaster`, data);
  }

  updateSlab(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/slabmaster/${id}`, data);
  }

  deleteSlab(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/slabmaster/${id}`);
  }

  getSlabById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/slabmaster/${id}`);
  }

  // Department Grade Designation Mapping

  getAllDepartmentGradeDesignation(): Observable<any> {
    return this.http.get(`${this.hostURL}/department-grade-designation`);
  }

  getDepartmentGradeDesignationDropdowns(): Observable<any> {
    return this.http.get(`${this.hostURL}/department-grade-designation/dropdowns`);
  }

  getDepartmentGradeDesignationById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/department-grade-designation/${id}`);
  }

  createDepartmentGradeDesignation(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/department-grade-designation`, data);
  }

  updateDepartmentGradeDesignation(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/department-grade-designation/${id}`, data);
  }

  deleteDepartmentGradeDesignation(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/department-grade-designation/${id}`);
  }

  //Grade Master

  getAllGrade(): Observable<any> {
    return this.http.get(`${this.hostURL}/grade`);
  }

  createGrade(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/grade`, data);
  }

  updateGrade(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/grade/${id}`, data);
  }

  deleteGrade(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/grade/${id}`);
  }

  getGradeById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/grade/${id}`);
  }

  getGradeDepartment(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/grade/departments/${id}`);
  }

  //Employee Grade Master

  getAllEmployeegrade(): Observable<any> {
    return this.http.get(`${this.hostURL}/employeegrade`);
  }

  createEmployeegrade(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/employeegrade`, data);
  }

  updateEmployeegrade(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/employeegrade/${id}`, data);
  }

  deleteEmployeegrade(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/employeegrade/${id}`);
  }

  getEmployeegradeById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/employeegrade/${id}`);
  }

  //Attendance Calculation

  getAllAttendanceattribute(): Observable<any> {
    return this.http.get(`${this.hostURL}/attendance-calculation`);
  }

  createAttendanceattribute(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/attendance-calculation`, data);
  }

  updateAttendanceattribute(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/attendance-calculation/${id}`, data);
  }

  deleteAttendanceattribute(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/attendance-calculation/${id}`);
  }

  getAttendanceattributeById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/attendance-calculation/${id}`);
  }

  //Master Setting

  getAllMastersetting(): Observable<any> {
    return this.http.get(`${this.hostURL}/mastersetting`);
  }

  createMastersetting(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/mastersetting`, data);
  }

  updateMastersetting(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/mastersetting/${id}`, data);
  }

  deleteMastersetting(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/mastersetting/${id}`);
  }

  getMastersettingById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/mastersetting/${id}`);
  }

  //Salary Calculation

  getAllSalaryformula(): Observable<any> {
    return this.http.get(`${this.hostURL}/salary-calculation-formula`);
  }

  createSalaryformula(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/salary-calculation-formula`, data);
  }

  updateSalaryformula(id: number, data: any): Observable<any> {
    return this.http.put(
      `${this.hostURL}/salary-calculation-formula/${id}`,
      data,
    );
  }

  deleteSalaryformula(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/salary-calculation-formula/${id}`);
  }
  getSalaryformulaById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/salary-calculation-formula/${id}`);
  }

  downloadEmployeeSample(): Observable<Blob> {
    return this.http.get(
      `${this.hostURL}/temporary-enrollment/employeerecordSampleExport`,
      { responseType: "blob" },
    );
  }

  importEmployeeRecord(formData: FormData) {
    return this.http.post<any>(
      `${this.hostURL}/temporary-enrollment/employeerecordImport`,
      formData,
    );
  }

  downloadCategorySample(): Observable<Blob> {
    return this.http.get(
      `${this.hostURL}/category-designation/categorySampleExport`,
      { responseType: "blob" },
    );
  }
  importCategoryRecord(formData: FormData) {
    return this.http.post<any>(
      `${this.hostURL}/category-designation/categoryImport`,
      formData,
    );
  }
  downloadDesignationSample(categoryId: number): Observable<Blob> {
    return this.http.post(
      `${this.hostURL}/designation/designationSampleExport`,
      { category_id: categoryId },
      {
        responseType: "blob",
      },
    );
  }
  importDesignationRecord(formData: FormData) {
    return this.http.post<any>(
      `${this.hostURL}/designation/designationImport`,
      formData,
    );
  }

  downloadPapldesignationSample(): Observable<Blob> {
    return this.http.get(
      `${this.hostURL}/papl-designation/papldesignationSampleExport`,
      { responseType: "blob" },
    );
  }
  importPapldesignationRecord(formData: FormData) {
    return this.http.post<any>(
      `${this.hostURL}/papl-designation/papldesignationImport`,
      formData,
    );
  }
  downloadEarningSample(): Observable<Blob> {
    return this.http.get(`${this.hostURL}/earning/earningSampleExport`, {
      responseType: "blob",
    });
  }
  importEarningRecord(formData: FormData) {
    return this.http.post<any>(
      `${this.hostURL}/earning/earningImport`,
      formData,
    );
  }
  downloadDeductionSample(): Observable<Blob> {
    return this.http.get(`${this.hostURL}/deduction/deductionSampleExport`, {
      responseType: "blob",
    });
  }
  importDeductionRecord(formData: FormData) {
    return this.http.post<any>(
      `${this.hostURL}/deduction/deductionImport`,
      formData,
    );
  }

  //Leave Master

  getAllLeave(): Observable<any> {
    return this.http.get(`${this.hostURL}/leave-type`);
  }

  createLeave(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/leave-type`, data);
  }

  updateLeave(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/leave-type/${id}`, data);
  }

  deleteLeave(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/leave-type/${id}`);
  }

  getLeaveById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/leave-type/${id}`);
  }

  getLeaveTypeById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/leave-type/leave-type/${id}`);
  }

  //Leave Configuration/Policy

  createLeavepolicy(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/leavepolicy`, data);
  }

  updateLeavepolicy(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/leavepolicy/${id}`, data);
  }

  deleteLeavepolicy(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/leavepolicy/${id}`);
  }

  getAllLeavepoliy(): Observable<any> {
    return this.http.get(`${this.hostURL}/leavepolicy`);
  }

  getLeavepolicyById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/leavepolicy/${id}`);
  }

  // Leave Policy PCC

  setLeavePolicyPCC(data: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/leavepolicy/set-leave-policy-pcc`,
      data,
    );
  }

  //Leave Policy Employee

  setEmployeeLeavePolicy(data: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/leavepolicy/set-leave-policy-employee`,
      data,
    );
  }

  //Leave request

  createLeaverequest(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/leaverequest`, data);
  }

  updateLeaverequest(id: number, data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/leaverequest/update/${id}`, data);
  }

  deleteLeaverequest(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/leaverequest/${id}`);
  }

  getAllLeaverequest(): Observable<any> {
    return this.http.get(`${this.hostURL}/leaverequest`);
  }

  getLeaverequestById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/leaverequest/${id}`);
  }
  employeeLeave(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/leaverequest/employee-leave`, data);
  }
  getAttachmentStatus(data: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/leaverequest/attachment-status`,
      data,
    );
  }

  getEmployeeLeaveTypeBalance(data: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/leaverequest/employee-leave-type-balance`,
      data,
    );
  }

  // Holiday

  getAllHoliday(): Observable<any> {
    return this.http.get(`${this.hostURL}/holiday`);
  }
  getAllHolidayListDropDown(): Observable<any> {
    return this.http.get(`${this.hostURL}/holiday/dropdownlist`);
  }
  createHoliday(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/holiday`, data);
  }
  updateHolidayGroup(data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/holiday/update-group`, data);
  }
  deleteHolidayGroup(ids: number[]): Observable<any> {
    return this.http.delete(`${this.hostURL}/holiday/delete-group`, {
      body: { ids },
    });
  }
  getHolidayById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/holiday/${id}`);
  }
  saveBranchHoliday(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/holiday/save-branch-holiday`, data);
  }
  getBranchWiseHoliday(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/holiday/branch-holiday-list`, data);
  }
  updateBranchHoliday(data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/holiday/update-branch-holiday`, data);
  }
  deleteBranchHoliday(data: any): Observable<any> {
    return this.http.delete(`${this.hostURL}/holiday/delete-branch-holiday`, {
      params: data,
    });
  }

  // Holiday Calendar

  getAllHolidayCalendarList(): Observable<any> {
    return this.http.get(`${this.hostURL}/holiday-calendar/list`);
  }

  getAllHolidayCalendar(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/holiday-calendar`, {
      params: data,
    });
  }

  //Calculation Master
  getAllCalculationmaster(): Observable<any> {
    return this.http.get(`${this.hostURL}/calculation-master`);
  }
  createCalculationmaster(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/calculation-master`, data);
  }
  updateCalculationmaster(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/calculation-master/${id}`, data);
  }
  deleteCalculationmaster(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/calculation-master/${id}`);
  }
  getCalculationmasterById(name: string): Observable<any> {
    return this.http.get(`${this.hostURL}/calculation-master/${name}`);
  }

  //leave details create
  createLeavedetails(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/leave-details`, data);
  }
  updateLeavedetails(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/leave-details/${id}`, data);
  }
  deleteLeavedetails(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/leave-details/${id}`);
  }
  getLeavedetailsById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/leave-details/${id}`);
  }
  getEmployeeleavedetails(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/leave-details/employee`, data);
  }
  // Employee  List
  getAllEmployee(params?: any): Observable<any> {
    return this.http.get(`${this.hostURL}/enrollment`, {
      params: params,
    });
  }

  //Employee Exit
  exitEmployee(data: any) {
    return this.http.post(`${this.hostURL}/enrollment/exit_employee`, data);
  }

  //Check Exit Eligibility
  getExitEligibility(data: any) {
    return this.http.post(`${this.hostURL}/enrollment/check_exit`, data);
  }

  getTemporaryExitEmployee(): Observable<any> {
    return this.http.get(`${this.hostURL}/enrollment/temporary-exit`);
  }

  employeeWiseExit(papl_id: string): Observable<any> {
    return this.http.get(
      `${this.hostURL}/enrollment/employee-wise-exit/${papl_id}`,
    );
  }
  approveExit(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/enrollment/approve-exit`, data);
  }
  rejectExit(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/enrollment/reject-exit`, data);
  }

  checkBlacklist(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/enrollment/check-blacklist`, data);
  }
  blacklistEmployee(data: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/enrollment/blacklist-employee`,
      data,
    );
  }
  getBlacklistedEmployee(): Observable<any> {
    return this.http.get(`${this.hostURL}/enrollment/blacklist`);
  }
  approveBlacklist(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/enrollment/approve-blacklist`, data);
  }
  rejectBlacklist(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/enrollment/reject-blacklist`, data);
  }

  // Department Master
  getAllDepartments(): Observable<any> {
    return this.http.get(`${this.hostURL}/department`);
  }
  createDepartment(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/department`, data);
  }
  updateDepartment(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/department/${id}`, data);
  }
  deleteDepartment(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/department/${id}`);
  }
  getDepartmentById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/department/${id}`);
  }

  //CreateProfitcostFormulaMapping
  getAllProfitcostFormulaMapping(): Observable<any> {
    return this.http.get(`${this.hostURL}/profitcost-center-formula-mapping`);
  }
  createProfitcostFormulaMapping(data: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/profitcost-center-formula-mapping`,
      data,
    );
  }
  updateProfitcostFormulaMapping(id: number, data: any): Observable<any> {
    return this.http.put(
      `${this.hostURL}/profitcost-center-formula-mapping/${id}`,
      data,
    );
  }
  deleteProfitcostFormulaMapping(id: number): Observable<any> {
    return this.http.delete(
      `${this.hostURL}/profitcost-center-formula-mapping/${id}`,
    );
  }
  getProfitcostFormulaMappingById(id: number): Observable<any> {
    return this.http.get(
      `${this.hostURL}/profitcost-center-formula-mapping/${id}`,
    );
  }

  //Create EmployeeFormulaMapping
  getAllEmployeeFormulaMapping(): Observable<any> {
    return this.http.get(`${this.hostURL}/employee-formula-mapping`);
  }
  createEmployeeFormulaMapping(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/employee-formula-mapping`, data);
  }
  updateEmployeeFormulaMapping(id: number, data: any): Observable<any> {
    return this.http.put(
      `${this.hostURL}/employee-formula-mapping/${id}`,
      data,
    );
  }
  deleteEmployeeFormulaMapping(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/employee-formula-mapping/${id}`);
  }
  getEmployeeFormulaMappingById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/employee-formula-mapping/${id}`);
  }

  //salary
  getSalarySlipGenerate(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/salary-slip-generate`, data);
  }

  // Download Salary Sheet
  downloadSalarySheet(data: any) {
    return this.http.post(
      `${this.hostURL}/salary-slip-generate/salarysheet`,
      data,
      { responseType: "blob" },
    );
  }

  // Leave Policy
  getLeavePolicy(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/leaverequest/leavepolicy`, data);
  }

  // Age Range By Employee Type
  getEmployeeTypeAgeRange(): Observable<any> {
    return this.http.get(`${this.hostURL}/employee-type/age-range`);
  }

  // Get ESIC code & PF code w.r.t. Branch
  getPfEsicByBranch(branchId: number): Observable<any> {
    return this.http.post(`${this.hostURL}/location/branch-pf-esic-code`, {
      branchId,
    });
  }
  // Branch Attendance Type
  getAllAttendanceType(): Observable<any> {
    return this.http.get(`${this.hostURL}/branch-attendance-type`);
  }
  createAttendanceType(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/branch-attendance-type`, data);
  }
  updateAttendanceType(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/branch-attendance-type/${id}`, data);
  }
  deleteAttendanceType(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/branch-attendance-type/${id}`);
  }
  getAttendanceTypeById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/branch-attendance-type/${id}`);
  }

  findAttendanceType(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/branch-attendance-type/find`, data);
  }

  findAteendanceNhfh(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/attendance/getAttendanceNhfh`, data);
  }
  // formula master
  getAllFormulaMaster(): Observable<any> {
    return this.http.get(`${this.hostURL}/formula-master`);
  }
  createFormulaMaster(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/formula-master`, data);
  }
  updateFormulaMaster(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/formula-master/${id}`, data);
  }
  deleteFormulaMaster(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/formula-master/${id}`);
  }
  getFormulaMasterById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/formula-master/${id}`);
  }

  //employee type
  getAllEmployeeType(): Observable<any> {
    return this.http.get(`${this.hostURL}/employee-type`);
  }

  getEmployeeTypeById(id: number): Observable<any> {
    return this.http.get(`${this.hostURL}/employee-type/${id}`);
  }
  createEmployeeType(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/employee-type`, data);
  }
  updateEmployeeType(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/employee-type/${id}`, data);
  }
  deleteEmployeeType(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/employee-type/${id}`);
  }

  updateEmployeeMaster(id: string, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/enrollment/edit/${id}`, data);
  }

  //bank details
  updateBankDetails(id: string, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/enrollment/editbankdetails/${id}`, data);
  }

  //nominee
  updateNominee(id: string, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/enrollment/editnominee/${id}`, data);
  }

  //family details
  updateFamilyDetails(id: string, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/enrollment/editfamilydetails/${id}`, data);
  }

  //epf esic
  updateEpfEsic(id: string, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/enrollment/editepfesic/${id}`, data);
  }

  //qualification
  updateQualification(id: string, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/enrollment/editqualification/${id}`, data);
  }

  // pt rules

  getAllPtRules(): Observable<any> {
    return this.http.get(`${this.hostURL}/pt-rules`);
  }

  createPtRule(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/pt-rules`, data);
  }

  updatePtRule(id: number, data: any): Observable<any> {
    return this.http.put(`${this.hostURL}/pt-rules/${id}`, data);
  }

  deletePtRule(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/pt-rules/${id}`);
  }
}
